import { ECisalikvynos } from 'enums/isin/udaje/cisalikvynos';

const alikVynosSelect = [
    {
        value: ECisalikvynos._1,
        labelcz: 'ISIN_EMISE_WARRANT_1'
    },
    {
        value: ECisalikvynos._2,
        labelcz: 'ISIN_EMISE_WARRANT_2'
    },
    {
        value: ECisalikvynos._3,
        labelcz: 'ISIN_EMISE_WARRANT_3'
    },
    {
        value: ECisalikvynos._9,
        labelcz: 'ISIN_EMISE_WARRANT_9'
    },
    {
        value: ECisalikvynos._4,
        labelcz: 'ISIN_EMISE_WARRANT_4'
    },
    {
        value: ECisalikvynos._10,
        labelcz: 'ISIN_EMISE_WARRANT_10'
    },
    {
        value: ECisalikvynos._13,
        labelcz: 'ISIN_EMISE_WARRANT_JINA'
    }
];
export const alikVynosSelectZero = [
    {
        value: ECisalikvynos._8,
        labelcz: 'ISIN_EMISE_WARRANT_ZERO_8'
    },
    {
        value: ECisalikvynos._7,
        labelcz: 'ISIN_EMISE_WARRANT_ZERO_7'
    },
    {
        value: ECisalikvynos._5,
        labelcz: 'ISIN_EMISE_WARRANT_ZERO_5'
    },
    {
        value: ECisalikvynos._11,
        labelcz: 'ISIN_EMISE_WARRANT_ZERO_11'
    },
    {
        value: ECisalikvynos._6,
        labelcz: 'ISIN_EMISE_WARRANT_ZERO_6'
    },
    {
        value: ECisalikvynos._12,
        labelcz: 'ISIN_EMISE_WARRANT_ZERO_12'
    },
    {
        value: ECisalikvynos._13,
        labelcz: 'ISIN_EMISE_WARRANT_ZERO_JINA'
    }
];

export default alikVynosSelect;
